// export const DEFAULT_TIMEOUT = 30000; // 30 seconds
import { sanitizeSessionUuids } from "@utils/sessionUuid";

export const DEFAULT_TIMEOUT = 300000; // 5 minutes

export const MICRO_SERVICE_ROUTES = {
	NOTIFICATIONS: "/notifications",
	USERS: "/users",
	INSTITUTES: "/institutes",
	CERTIFICATES: "/certificates",
	MEMBERS: "/members",
};
export const API_ROUTES = {
	AUTH: `${MICRO_SERVICE_ROUTES.USERS}/auth/v1`,
	EQUIPMENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/equipment`,
	LABS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/labs`,
	USERS: `${MICRO_SERVICE_ROUTES.USERS}/users/v1`,
	NOTIFICATIONS: `${MICRO_SERVICE_ROUTES.NOTIFICATIONS}/notifications`,
	CERTIFICATES: `${MICRO_SERVICE_ROUTES.CERTIFICATES}/certificates`,
	MEMBERS: `${MICRO_SERVICE_ROUTES.MEMBERS}/members`,
} as const;

export const API_PATHS = {
	AUTH: {
		SIGN_IN: "/login",
		SIGN_UP: "/email/register",
		VERIFY_EMAIL: "/verify-email",
		FORGOT_PASSWORD: "/forgot-password",
		RESET_PASSWORD: "/reset-password",
		CHANGE_PASSWORD: "/change-password",
		VERIFY_OTP: "/verify-otp",
		RESEND_OTP: "/resend-otp",
		VERIFY_RESET_TOKEN: "/verify-reset-token",
		RESEND_VERIFICATION_LINK: "/resend-verification-link",
	},
	USER: {
		GET_PROFILE: "/profile",
		PROFILE_IMAGE_UPLOAD_URL: "/profile/image/upload-url",
		PROFILE_IMAGE_UPDATE: "/profile/image",
		COMMITTE_MEMBERS: "/committee-members",
		COMMITTE_MEMBERS_BULK: "/committee-members/bulk",
		COMMITTEE_MEMBER_DETAILS: (uuid: string) => `/committee-members/${uuid}`,
		ACTIVATE_MEMBER: (uuid: string) => `/${uuid}/activate`,
		DEACTIVATE_MEMBER: (uuid: string) => `/${uuid}/deactivate`,
		USER_ROLES: "/user-role",
		PERMISSION_MODULE: "/permission-module",
		ROLES: "/roles",
		ADMIN_USERS: "/users/v1/admin-users",
	},

	INSTITIUTE: {
		FILE_UPLOAD_URL: "/attachments/upload",
		TECHNOLOGY: "/technology",
		MEMBER_TYPES: "/memberType",
		DESIGNATION: "/designation",
		QUALIFICATION: "/qualification",
		UPDATE_QUALIFICATION: (uuid: string) => `/qualification/${uuid}`,
		ORGANIZATION_TYPE: "/organization-type",
		ORGANIZATION_CATEGORY: "/system/organization-category",
		UPDATE_ORGANIZATION_TYPE: (uuid: string) => `/organization-type/${uuid}`,
		DELETE_ORGANIZATION_TYPE: (uuid: string) => `/organization-type/${uuid}`,
		ATTACHMENT_TYPE: "/attachment-type",
		UPDATE_ATTACHMENT_TYPE: (uuid: string) => `/attachment-type/${uuid}`,
		ATTACHMENT_TYPE_OPTION: "/attachment-type-option",
		UPDATE_ATTACHMENT_TYPE_OPTION: (uuid: string) => `/attachment-type-option/${uuid}`,
		INSTITUTE_FACILITY: "/institute-facility",
		UPDATE_INSTITUTE_FACILITY: (uuid: string) => `/institute-facility/${uuid}`,
		FACILITY_TYPE_FILTER: "/system/filters/facility-type",
		PAYMENT_MODE_FILTER: "/system/filters/payment-mode",
		EMPLOYMENT_TYPE_FILTER: "/system/filters/employment-type",
		TECH_QUALIFICATION: "/tech-qualification",
		PROVINCE: "/province",
		GET_DIVISION_BY_PROVINCE: "/division/province",
		GET_DISTRICTS_BY_DIVISION: "/district/division",
		GET_TEHSILS_BY_DISTRICT: "/tehsil/district",
		GET_CITIES_BY_DISTRICT: "/city/district",
		GET_ALL_UC: "/union-council",
		COURSE_STREAM: "/course-stream",
		UPDATE_COURSE_STREAM: (uuid: string) => `/course-stream/${uuid}`,
		COURSE_LEVEL: "/course-level",
		COMPETENCY_POINTS: "/competency-points",
		COMPETENCY_POINT_BY_UUID: (uuid: string) => `/competency-points/${uuid}`,
		EXAM_SYSTEM: "/exam-system",
		COURSE_NOTIFYING_AUTHORITY: "/course-notifying-authority",
		COURSE_CATEGORY: "/course-category",
		COURSE_SCHEME: "/course-scheme",
		COURSE_SCHEME_BY_UUID: (uuid: string) => `/course-scheme/${uuid}`,
		COURSE_DURATION: "/course-duration",
		COURSE_LABEL: "/course-label",
		COURSE_ASSIGN: "/course-assign",
		COURSE_ASSIGN_BY_UUID: (uuid: string) => `/course-assign/${uuid}`,
		COURSE_ASSIGN_SPECIAL_INITIATIVE: "/course-assign/special-initiative",
		COURSE_ASSIGN_COURSES: "/course-assign/courses",
		SUBJECTS: "/subjects",
		UPDATE_SUBJECT: (uuid: string) => `/subjects/${uuid}`,
		DELETE_SUBJECT: (uuid: string) => `/subjects/${uuid}`,
		COURSES: "/course",
		COURSE_CATEGORIES: "/course/categories",
		COURSE_TERM_COUNT: "/course/term-count",
		VALIDATE_COURSE_EXISTENCE: "/course/validate-existence",
		REVISE_COURSE: (uuid: string) => `/course/${uuid}/revise`,
		COURSE_REQUESTS: "/course/requests",
		COURSE_DETAILS: (uuid: string) => `/course/${uuid}`,
		COURSE_CONTENTS: (uuid: string) => `/course/${uuid}/contents`,
		COURSE_STATUS: (uuid: string) => `/course/${uuid}/status`,
		COURSE_ATTACHMENT_LABEL: "/course-attachment-label",
		COURSE_APPROVE: (uuid: string) => `/course/${uuid}/approve`,
		COURSE_REJECT: (uuid: string) => `/course/${uuid}/reject`,
		SECTOR: "/sector",
		SECTOR_BY_UUID: (uuid: string) => `/sector/${uuid}`,
		ASSESSMENT_BODY: "/assessment-body",
		ASSESSMENT_BODY_BY_UUID: (uuid: string) => `/assessment-body/${uuid}`,
		PRIORITY: "/priority",
		EVENT_TYPE: "/event-type",
		APPLIES_TO: "/applies-to",
		APPLICATIONS_PENDING: "/applications/admin/pending",
		APPLICATIONS_SCRUTINIZED: "/applications/admin/scrutinized",
		APPLICATIONS_INSPECTED: "/applications/inspected",
		APPLICATIONS_CHECKED: "/applications/checked",
		APPLICATIONS_VERIFIED: "/applications/verified",
		APPLICATIONS_REJECTED: "/applications/admin/rejected",
		APPLICATIONS_REFERRED_BACK: "/applications/admin/referred-back",
		APPLICATIONS_APPROVED: "/applications/admin/approved",
		APPLICATIONS_APPEALS: "/applications/appeals",
		DASHBOARD_STATS: "/dashboard/stats",
		DASHBOARD_PIE_STATS: "/dashboard/pie-stats",
		DASHBOARD_BAR_STATS: "/dashboard/bar-stats",
		APPLICATION_PREDICTION: (applicationId: string) => `/applications/${applicationId}/prediction`,
	},
	ADMISSIONS: {
		QUOTA: "/admission-quota",
	},

	NOTIFICATIONS: {
		READ: "/read",
		STREAM: "/user/{id}/stream",
	},
	CERTIFICATES: {
		GET_DETAILS: "/details",
		DOWNLOAD: "/download",
	},
};

const ACTIONS = {
	REJECT: "reject",
};

const appendReportSessionUuidParams = (searchParams: URLSearchParams, sessionUuids?: string[]): void => {
	sanitizeSessionUuids(sessionUuids)?.forEach(sessionUuid => searchParams.append("sessionUuid", sessionUuid));
};

const appendMisReportFilterParams = (
	searchParams: URLSearchParams,
	params: {
		districtUuid?: string;
		instituteUuid?: string;
		courseUuid?: string;
		organizationUuid?: string;
	},
): void => {
	if (params.districtUuid) searchParams.append("districtUuid", params.districtUuid);
	if (params.instituteUuid) searchParams.append("instituteUuid", params.instituteUuid);
	if (params.courseUuid) searchParams.append("courseUuid", params.courseUuid);
	if (params.organizationUuid) searchParams.append("organizationUuid", params.organizationUuid);
};

const buildReportSessionUuidQuery = (sessionUuids?: string[]): string => {
	const searchParams = new URLSearchParams();
	appendReportSessionUuidParams(searchParams, sessionUuids);
	return searchParams.toString();
};

export const SERVER_ROUTES = {
	AUTH: {
		SIGN_IN: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_IN,
		SIGN_UP: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_UP,
		VERIFY_EMAIL: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_EMAIL,
		FORGOT_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.FORGOT_PASSWORD,
		RESET_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.RESET_PASSWORD,
		CHANGE_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.CHANGE_PASSWORD,
		VERIFY_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_OTP,
		RESEND_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.RESEND_OTP,
		VERIFY_RESET_TOKEN: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_RESET_TOKEN,
		RESEND_VERIFICATION_LINK: API_ROUTES.AUTH + API_PATHS.AUTH.RESEND_VERIFICATION_LINK,
	},
	USER: {
		GET_PROFILE: API_ROUTES.AUTH + API_PATHS.USER.GET_PROFILE,
		PROFILE_IMAGE_UPLOAD_URL: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPLOAD_URL,
		PROFILE_IMAGE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPDATE,
		PROFILE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.GET_PROFILE,
		COMMITTE_MEMBERS: API_ROUTES.USERS + API_PATHS.USER.COMMITTE_MEMBERS,
		COMMITTE_MEMBERS_BULK: API_ROUTES.USERS + API_PATHS.USER.COMMITTE_MEMBERS_BULK,
		COMMITTEE_MEMBER_DETAILS: (uuid: string) => API_ROUTES.USERS + API_PATHS.USER.COMMITTEE_MEMBER_DETAILS(uuid),
		ACTIVATE_MEMBER: (uuid: string) => API_ROUTES.USERS + API_PATHS.USER.ACTIVATE_MEMBER(uuid),
		DEACTIVATE_MEMBER: (uuid: string) => API_ROUTES.USERS + API_PATHS.USER.DEACTIVATE_MEMBER(uuid),
		USERS_ROLES: `${MICRO_SERVICE_ROUTES.USERS}${API_PATHS.USER.USER_ROLES}`,
		USER_ROLE_BY_UUID: (uuid: string) => `${MICRO_SERVICE_ROUTES.USERS}${API_PATHS.USER.USER_ROLES}/${uuid}`,
		PERMISSION_MODULES: `${MICRO_SERVICE_ROUTES.USERS}${API_PATHS.USER.PERMISSION_MODULE}`,
		ADMIN_USERS: `${MICRO_SERVICE_ROUTES.USERS}${API_PATHS.USER.ADMIN_USERS}`,
	},

	NOTIFICATIONS: {
		NOTIFICATIONS: API_ROUTES.NOTIFICATIONS,
		READ: (id: string) => `${API_ROUTES.NOTIFICATIONS}/${id}${API_PATHS.NOTIFICATIONS.READ}`,
		STREAM: (id: string) => `${API_ROUTES.NOTIFICATIONS}${API_PATHS.NOTIFICATIONS.STREAM.replace("{id}", id)}`,
	},
	EQUIPMENTS: {
		GET: (limit: number, page: number, search?: string) => {
			const base = `${API_ROUTES.EQUIPMENTS}?limit=${limit}&page=${page}`;
			return search?.trim() ? `${base}&search=${encodeURIComponent(search.trim())}` : base;
		},
		CREATE: API_ROUTES.EQUIPMENTS,
		UPDATE: (id: string) => `${API_ROUTES.EQUIPMENTS}/${id}`,
		DELETE: (id: string) => `${API_ROUTES.EQUIPMENTS}/${id}`,
	},
	LABS: {
		GET: (limit: number, page: number, search?: string) => {
			const base = `${API_ROUTES.LABS}?limit=${limit}&page=${page}`;
			return search?.trim() ? `${base}&search=${encodeURIComponent(search.trim())}` : base;
		},
		CREATE: API_ROUTES.LABS,
		UPDATE: (uuid: string) => `${API_ROUTES.LABS}/${uuid}`,
		DELETE: (uuid: string) => `${API_ROUTES.LABS}/${uuid}`,
	},
	INSTITUTE: {
		ATTACHMENT_UPLOAD: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.FILE_UPLOAD_URL,
		APPLICATIONS_REJECTED: (applicationId: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/${ACTIONS.REJECT}`,
		GET_INSTITUTES: MICRO_SERVICE_ROUTES.INSTITUTES + "/institutes",
		GET_INSTITUTES_LIST: (params: {
			page: number;
			limit: number;
			search?: string;
			organizationName?: string;
			districtUuid?: string;
			sessionUuids?: string[];
		}) => {
			const searchParams = new URLSearchParams();
			searchParams.set("page", String(params.page));
			searchParams.set("limit", String(params.limit));
			if (params.search?.trim()) searchParams.set("search", params.search.trim());
			if (params.organizationName) searchParams.set("organizationName", params.organizationName);
			if (params.districtUuid) searchParams.set("districtUuid", params.districtUuid);
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/institutes?${searchParams.toString()}`;
		},
		GET_INSTITUTES_INCLUDING_PUBLIC: `${MICRO_SERVICE_ROUTES.INSTITUTES}/institutes/including-public`,
		GET_APPLICATION_DETAILS: (applicationId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}`,
		GET_APPLICATION_COURSE_LABS: (
			catalogCourseUuid: string,
			page: number,
			limit: number,
			applicationCourseId?: string,
			search?: string,
		) => {
			const params = new URLSearchParams({
				page: String(page),
				limit: String(limit),
			});
			if (applicationCourseId?.trim()) {
				params.set("applicationCourseId", applicationCourseId.trim());
			}
			if (search?.trim()) {
				params.set("search", search.trim());
			}
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/labs/courses/${catalogCourseUuid}/labs?${params.toString()}`;
		},
		GET_LAB_EQUIPMENTS: (
			labUuid: string,
			page: number,
			limit: number,
			applicationCourseId: string,
			search?: string,
		) => {
			const searchParams = new URLSearchParams({
				page: String(page),
				limit: String(limit),
				applicationCourseId,
			});
			if (search?.trim()) {
				searchParams.set("search", search.trim());
			}
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/labs/${labUuid}?${searchParams.toString()}`;
		},
		GET_COURSES_LAB_EQUIPMENT_DETAILS: (applicationId: string, courseUuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/application-courses/${courseUuid}/lab-equipments`,
		PUT_LAB_EQUIPMENTS_SCRUTINY: (applicationInstituteUuid: string, applicationCourseUuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationInstituteUuid}/application-courses/${applicationCourseUuid}/lab-equipments/scrutiny`,
		GET_APPLICATION_WITH_COMMITTEE: (applicationUuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationUuid}/application-with-committee`,
		SUBMIT_APPLICATION_SCRUTINY: (id: number) => MICRO_SERVICE_ROUTES.INSTITUTES + `/applications/${id}/scrutinize`,
		ISSUE_CERTIFICATE: (id: string) => MICRO_SERVICE_ROUTES.INSTITUTES + `/certificates/${id}/issue-certificate`,
		PRINT_CERTIFICATE: (id: string) => MICRO_SERVICE_ROUTES.INSTITUTES + `/applications/${id}/print-certificate`,
		SUBMIT_APPLICATION_COMMITTEE: MICRO_SERVICE_ROUTES.INSTITUTES + "/application-committee",
		RECONSTITUTE_COMMITTEE: (committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/${committeeId}/reconstitute`,
		GET_COMMITTEE_DETAILS: (committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/committee-approval-pending/${committeeId}`,
		GET_APPLICATION_COMMITTEE: (committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/${committeeId}`,
		APPROVE_COMMITTEE: (committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/${committeeId}/approve`,
		FINALIZE_COMMITTEE: (committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/${committeeId}/finalize`,
		GET_INSTITUTE_DETAILS: (instituteId: string) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/institutes/${instituteId}`,
		UNAUTHORIZED_INSTITUTE_REPORTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/unauthorized-institutes/reports`,
		UNAUTHORIZED_INSTITUTE_REPORT_APPROVE: (reportId: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/unauthorized-institutes/reports/${reportId}/approve`,
		UNAUTHORIZED_INSTITUTE_REPORT_REJECT: (reportId: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/unauthorized-institutes/reports/${reportId}/reject`,
		EMPLOYER_SDED_ENDORSEMENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/employers/sded-endorsement`,
		EMPLOYER_SDED_ENDORSEMENT: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/employers/sded-endorsement/${uuid}`,
		// NOTE: This API is not in use
		// GET_INSPECTION_TYPE: MICRO_SERVICE_ROUTES.INSTITUTES + "/inspection-types",
		GET_ALL_TECHNOLOGIES: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.TECHNOLOGY,
		GET_MEMBER_TYPES: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.MEMBER_TYPES,
		GET_ALL_DESIGNATIONS: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.DESIGNATION,
		GET_HEIGHST_QUALIFICATION: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.QUALIFICATION,
		GET_QUALIFICATIONS: (page: number, limit: number, search?: string) => {
			const base = `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.QUALIFICATION}?page=${page}&limit=${limit}`;
			return search?.trim() ? `${base}&search=${encodeURIComponent(search.trim())}` : base;
		},
		CREATE_QUALIFICATION: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.QUALIFICATION,
		UPDATE_QUALIFICATION: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.UPDATE_QUALIFICATION(uuid),
		GET_ORGANIZATION_TYPE: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.ORGANIZATION_TYPE,
		GET_ORGANIZATION_TYPES: (page: number, limit: number, search?: string) => {
			const base = `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.ORGANIZATION_TYPE}?page=${page}&limit=${limit}`;
			return search?.trim() ? `${base}&search=${encodeURIComponent(search.trim())}` : base;
		},
		CREATE_ORGANIZATION_TYPE: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.ORGANIZATION_TYPE,
		UPDATE_ORGANIZATION_TYPE: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.UPDATE_ORGANIZATION_TYPE(uuid),
		DELETE_ORGANIZATION_TYPE: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.DELETE_ORGANIZATION_TYPE(uuid),
		GET_ORGANIZATION_CATEGORY: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.ORGANIZATION_CATEGORY,
		GET_ATTACHMENT_TYPE: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.ATTACHMENT_TYPE,
		GET_ATTACHMENT_TYPES: (page: number, limit: number, search?: string) => {
			const base = `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.ATTACHMENT_TYPE}?page=${page}&limit=${limit}`;
			return search?.trim() ? `${base}&search=${encodeURIComponent(search.trim())}` : base;
		},
		CREATE_ATTACHMENT_TYPE: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.ATTACHMENT_TYPE,
		UPDATE_ATTACHMENT_TYPE: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.UPDATE_ATTACHMENT_TYPE(uuid),
		GET_ATTACHMENT_TYPE_OPTION: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.ATTACHMENT_TYPE_OPTION,
		GET_ATTACHMENT_TYPE_OPTIONS: (page: number, limit: number, search?: string) => {
			const base = `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.ATTACHMENT_TYPE_OPTION}?page=${page}&limit=${limit}`;
			return search?.trim() ? `${base}&search=${encodeURIComponent(search.trim())}` : base;
		},
		CREATE_ATTACHMENT_TYPE_OPTION: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.ATTACHMENT_TYPE_OPTION,
		UPDATE_ATTACHMENT_TYPE_OPTION: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.UPDATE_ATTACHMENT_TYPE_OPTION(uuid),
		GET_INSTITUTE_FACILITY: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.INSTITUTE_FACILITY,
		GET_INSTITUTE_FACILITIES: (page: number, limit: number, search?: string) => {
			const base = `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.INSTITUTE_FACILITY}?page=${page}&limit=${limit}`;
			return search?.trim() ? `${base}&search=${encodeURIComponent(search.trim())}` : base;
		},
		CREATE_INSTITUTE_FACILITY: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.INSTITUTE_FACILITY,
		UPDATE_INSTITUTE_FACILITY: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.UPDATE_INSTITUTE_FACILITY(uuid),
		GET_FACILITY_TYPE_FILTER: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.FACILITY_TYPE_FILTER,
		GET_PAYMENT_MODE_FILTER: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.PAYMENT_MODE_FILTER,
		GET_EMPLOYMENT_TYPE_FILTER: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.EMPLOYMENT_TYPE_FILTER,
		GET_TECH_QUALIFICATION: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.TECH_QUALIFICATION,
		GET_ALL_PROVICE: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.PROVINCE,
		GET_ALL_DIVISIONS_BY_PROVINCE: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_DIVISION_BY_PROVINCE}/${id}/divisions`,
		GET_ALL_DISTRICTS_BY_DIVISION: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_DISTRICTS_BY_DIVISION}/${id}/districts`,
		GET_ALL_TEHSILS_BY_DISTRICT: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_TEHSILS_BY_DISTRICT}/${id}/tehsils`,
		GET_ALL_CITIES_BY_DISTRICT: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_CITIES_BY_DISTRICT}/${id}/cities`,
		GET_ALL_UC: `${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_ALL_UC}`,
		GET_COURSE_STREAM: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_STREAM,
		GET_COURSE_STREAM_WITH_STATUS: (status: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_STREAM}?status=${encodeURIComponent(status)}`,
		UPDATE_COURSE_STREAM: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.UPDATE_COURSE_STREAM(uuid)}`,
		GET_COURSE_LEVEL: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_LEVEL,
		GET_COMPETENCY_POINTS: (page: number, limit: number, search?: string, isActive?: boolean) => {
			const params = new URLSearchParams({
				page: String(page),
				limit: String(limit),
			});
			if (search?.trim()) params.set("search", search.trim());
			if (typeof isActive === "boolean") params.set("isActive", String(isActive));
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COMPETENCY_POINTS}?${params.toString()}`;
		},
		GET_COMPETENCY_POINT: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COMPETENCY_POINT_BY_UUID(uuid),
		CREATE_COMPETENCY_POINT: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COMPETENCY_POINTS,
		UPDATE_COMPETENCY_POINT: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COMPETENCY_POINT_BY_UUID(uuid),
		DELETE_COMPETENCY_POINT: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COMPETENCY_POINT_BY_UUID(uuid),
		GET_EXAM_SYSTEM: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.EXAM_SYSTEM}?page=${page}&limit=${limit}`,
		GET_COURSE_NOTIFYING_AUTHORITY: (limit: number, page: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_NOTIFYING_AUTHORITY}?limit=${limit}&page=${page}`,
		GET_COURSE_CATEGORY: (page: number, limit: number, search?: string) => {
			const base = `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_CATEGORY}?page=${page}&limit=${limit}`;
			return search?.trim() ? `${base}&search=${encodeURIComponent(search.trim())}` : base;
		},
		CREATE_COURSE_CATEGORY: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_CATEGORY,
		GET_COURSE_SCHEME: (page: number, limit: number, search?: string, isActive?: boolean) => {
			const params = new URLSearchParams({
				page: String(page),
				limit: String(limit),
			});
			if (search?.trim()) params.set("search", search.trim());
			if (typeof isActive === "boolean") params.set("isActive", String(isActive));
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_SCHEME}?${params.toString()}`;
		},
		CREATE_COURSE_SCHEME: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_SCHEME,
		UPDATE_COURSE_SCHEME: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_SCHEME_BY_UUID(uuid),
		DELETE_COURSE_SCHEME: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_SCHEME_BY_UUID(uuid),
		GET_COURSE_DURATION: (page: number, limit: number, durationUnit?: string) => {
			const base = `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_DURATION}?page=${page}&limit=${limit}&isActive=true`;
			return durationUnit?.trim()
				? `${base}&durationUnit=${encodeURIComponent(durationUnit.trim())}`
				: base;
		},
		GET_COURSE_LABEL: (page: number, limit: number, search?: string, isRegular?: boolean) => {
			const params = new URLSearchParams();
			params.set("page", String(page));
			params.set("limit", String(limit));
			params.set("isActive", "true");
			if (search?.trim()) params.set("search", search.trim());
			if (typeof isRegular === "boolean") params.set("isRegular", String(isRegular));
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_LABEL}?${params.toString()}`;
		},
		GET_COURSE_ASSIGNMENTS: (
			page: number,
			limit: number,
			search?: string,
			filters?: { instituteUuid?: string; courseUuid?: string },
		) => {
			const params = new URLSearchParams();
			params.set("page", String(page));
			params.set("limit", String(limit));
			if (search?.trim()) params.set("search", search.trim());
			if (filters?.instituteUuid?.trim()) params.set("instituteUuid", filters.instituteUuid.trim());
			if (filters?.courseUuid?.trim()) params.set("courseUuid", filters.courseUuid.trim());
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_ASSIGN}?${params.toString()}`;
		},
		CREATE_COURSE_ASSIGNMENT: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_ASSIGN,
		GET_COURSE_ASSIGNMENT: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_ASSIGN_BY_UUID(uuid),
		UPDATE_COURSE_ASSIGNMENT: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_ASSIGN_BY_UUID(uuid),
		DELETE_COURSE_ASSIGNMENT: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_ASSIGN_BY_UUID(uuid),
		GET_SPECIAL_INITIATIVE_COURSE_ASSIGNMENTS: (
			page: number,
			limit: number,
			search?: string,
		) => {
			const params = new URLSearchParams();
			params.set("page", String(page));
			params.set("limit", String(limit));
			if (search?.trim()) params.set("search", search.trim());
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_ASSIGN_SPECIAL_INITIATIVE}?${params.toString()}`;
		},
		GET_COURSE_ASSIGN_COURSES: (page: number, limit: number, search?: string, isRegular?: boolean) => {
			const params = new URLSearchParams();
			params.set("page", String(page));
			params.set("limit", String(limit));
			if (search?.trim()) params.set("search", search.trim());
			if (typeof isRegular === "boolean") params.set("isRegular", String(isRegular));
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_ASSIGN_COURSES}?${params.toString()}`;
		},
		GET_SUBJECTS: (page: number, limit: number, search?: string) => {
			const base = `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.SUBJECTS}?page=${page}&limit=${limit}`;
			return search?.trim() ? `${base}&search=${encodeURIComponent(search.trim())}` : base;
		},
		GET_SUBJECT: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.UPDATE_SUBJECT(uuid),
		CREATE_SUBJECT: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.SUBJECTS,
		UPDATE_SUBJECT: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.UPDATE_SUBJECT(uuid),
		DELETE_SUBJECT: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.DELETE_SUBJECT(uuid),
		CREATE_COURSE: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSES,
		GET_COURSE_TERM_COUNT: (duration: number, durationUnit: string, examSystem?: string) => {
			const params = new URLSearchParams({
				duration: String(duration),
				durationUnit,
			});
			if (examSystem?.trim()) params.set("examSystem", examSystem.trim());
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_TERM_COUNT}?${params.toString()}`;
		},
		VALIDATE_COURSE_EXISTENCE:
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.VALIDATE_COURSE_EXISTENCE,
		GET_COURSES: (params: {
			page: number;
			limit: number;
			search?: string;
			sectorIds?: number[];
			courseStreamIds?: number[];
			courseStreamIdentifier?: string;
			isActive?: boolean;
			latestOnly?: boolean;
			status?: string;
			courseGroupId?: number;
			durationWeeks?: number;
			instituteUuid?: string;
			sortBy?: string;
			sortOrder?: "ASC" | "DESC";
		}) => {
			const searchParams = new URLSearchParams();
			searchParams.set("page", String(params.page));
			searchParams.set("limit", String(params.limit));
			if (params.search?.trim()) {
				searchParams.set("search", params.search.trim());
			}
			if (typeof params.isActive === "boolean") {
				searchParams.set("isActive", String(params.isActive));
			}
			if (typeof params.latestOnly === "boolean") {
				searchParams.set("latestOnly", String(params.latestOnly));
			}
			if (params.status?.trim()) {
				searchParams.set("status", params.status.trim());
			}
			if (params.courseGroupId != null && Number.isFinite(params.courseGroupId)) {
				searchParams.set("courseGroupId", String(params.courseGroupId));
			}
			if (params.durationWeeks != null && Number.isFinite(params.durationWeeks)) {
				searchParams.set("durationWeeks", String(params.durationWeeks));
			}
			if (params.instituteUuid?.trim()) {
				searchParams.set("instituteUuid", params.instituteUuid.trim());
			}
			if (params.sortBy?.trim()) {
				searchParams.set("sortBy", params.sortBy.trim());
			}
			if (params.sortOrder) {
				searchParams.set("sortOrder", params.sortOrder);
			}
			(params.sectorIds ?? []).forEach(id => searchParams.append("sectorIds", String(id)));
			(params.courseStreamIds ?? []).forEach(id => searchParams.append("courseStreamIds", String(id)));
			if (params.courseStreamIdentifier?.trim()) {
				searchParams.set("courseStreamIdentifier", params.courseStreamIdentifier.trim());
			}
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSES}?${query}`;
		},
		GET_COURSE_CATEGORIES: (params: {
			page: number;
			limit: number;
			search?: string;
			sectorIds?: number[];
			courseStreamIds?: number[];
			isActive?: boolean;
			sortBy?: string;
			sortOrder?: "ASC" | "DESC";
		}) => {
			const searchParams = new URLSearchParams();
			searchParams.set("page", String(params.page));
			searchParams.set("limit", String(params.limit));
			if (params.search?.trim()) {
				searchParams.set("search", params.search.trim());
			}
			if (typeof params.isActive === "boolean") {
				searchParams.set("isActive", String(params.isActive));
			}
			if (params.sortBy?.trim()) {
				searchParams.set("sortBy", params.sortBy.trim());
			}
			if (params.sortOrder) {
				searchParams.set("sortOrder", params.sortOrder);
			}
			(params.sectorIds ?? []).forEach(id => searchParams.append("sectorIds", String(id)));
			(params.courseStreamIds ?? []).forEach(id => searchParams.append("courseStreamIds", String(id)));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_CATEGORIES}?${query}`;
		},
		REVISE_COURSE: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.REVISE_COURSE(uuid)}`,
		GET_COURSE_DETAILS: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_DETAILS(uuid)}`,
		GET_COURSE_ATTACHMENT_LABELS:
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_ATTACHMENT_LABEL,
		GET_COURSE_CONTENTS: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_CONTENTS(uuid)}`,
		GET_COURSE_REQUESTS: (params: {
			page?: number;
			limit?: number;
			search?: string;
			status?: string;
			sectorIds?: number[];
			courseStreamIds?: number[];
		}) => {
			const searchParams = new URLSearchParams();
			if (params.page != null) searchParams.set("page", String(params.page));
			if (params.limit != null) searchParams.set("limit", String(params.limit));
			if (params.search) searchParams.set("search", params.search);
			if (params.status) searchParams.set("status", params.status);
			params.sectorIds?.forEach(id => searchParams.append("sectorIds", String(id)));
			params.courseStreamIds?.forEach(id => searchParams.append("courseStreamIds", String(id)));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_REQUESTS}${query ? `?${query}` : ""}`;
		},
		UPDATE_COURSE: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_DETAILS(uuid)}`,
		ADD_COURSE_CONTENTS: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_CONTENTS(uuid)}`,
		UPDATE_COURSE_STATUS: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_STATUS(uuid)}`,
		APPROVE_COURSE: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_APPROVE(uuid)}`,
		REJECT_COURSE: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSE_REJECT(uuid)}`,
		GET_SECTOR: (page: number, limit: number, search?: string, isActive?: boolean) => {
			const params = new URLSearchParams({
				page: String(page),
				limit: String(limit),
			});
			if (search?.trim()) params.set("search", search.trim());
			if (typeof isActive === "boolean") params.set("isActive", String(isActive));
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.SECTOR}?${params.toString()}`;
		},
		CREATE_SECTOR: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.SECTOR,
		UPDATE_SECTOR: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.SECTOR_BY_UUID(uuid),
		DELETE_SECTOR: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.SECTOR_BY_UUID(uuid),
		GET_ASSESSMENT_BODY: (page: number, limit: number, search?: string, isActive?: boolean) => {
			const params = new URLSearchParams({
				page: String(page),
				limit: String(limit),
			});
			if (search?.trim()) params.set("search", search.trim());
			if (typeof isActive === "boolean") params.set("isActive", String(isActive));
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.ASSESSMENT_BODY}?${params.toString()}`;
		},
		CREATE_ASSESSMENT_BODY: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.ASSESSMENT_BODY,
		UPDATE_ASSESSMENT_BODY: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.ASSESSMENT_BODY_BY_UUID(uuid),
		DELETE_ASSESSMENT_BODY: (uuid: string) =>
			MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.ASSESSMENT_BODY_BY_UUID(uuid),
		GET_APPLICATIONS_PENDING: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_PENDING}?`,

		GET_APPLICATIONS_SCRUTINIZED: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_SCRUTINIZED}?`,
		GET_APPLICATIONS_INSPECTED: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_INSPECTED}?`,
		GET_APPLICATIONS_CHECKED: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_CHECKED}?`,
		GET_APPLICATIONS_VERIFIED: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_VERIFIED}?`,
		GET_APPLICATIONS_REJECTED: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_REJECTED}?`,
		GET_APPLICATIONS_REFERRED_BACK: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_REFERRED_BACK}?`,
		GET_APPLICATIONS_APPROVED: `${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_APPROVED}?`,
		GET_APPLICATIONS_PENDING_REJECTION_PENDING: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-request-reject/pending?`,
		GET_APPLICATIONS_PENDING_REJECTION_VERIFY: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-request-reject/verify?`,
		GET_APPLICATIONS_PENDING_REJECTION_APPROVE: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-request-reject/approve?`,
		REQUEST_REJECTION: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-request-reject/request/${uuid}`,
		CANCEL_REJECTION_REQUEST: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-request-reject/cancel/${uuid}`,
		VERIFY_REJECTION_REQUEST: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-request-reject/verify/${uuid}`,
		APPROVE_REJECTION_REQUEST: (uuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-request-reject/approve/${uuid}`,
		GET_APPLICATIONS_APPEALS: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_APPEALS}?page=${page}&limit=${limit}`,
		GET_COMMITTEE_APPROVAL_PENDING: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/committee-approval-pending?`,
		GET_COMMITTEE_APPROVED: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/approved?`,
		GET_COMMITTEE_REJECTED: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/rejected?`,
		GET_RECONSTITUTE_PENDING: `${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/reconsitute-pending?`,
		GET_DASHBOARD_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/dashboard/stats`,
		GET_DASHBOARD_PIE_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/dashboard/pie-stats`,
		GET_DASHBOARD_BAR_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/dashboard/bar-stats`,
		GET_EXECUTIVE_DASHBOARD_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/dashboard/executive-stats`,
		/** Active institute streams for the executive dashboard stream filter. */
		GET_INSTITUTE_STREAMS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/institute-stream?isActive=true`,
		GET_EXECUTIVE_FILTER_OPTIONS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/dashboard/executive-filter-options`,
		GET_INSTITUTES_APPROVED: `${MICRO_SERVICE_ROUTES.INSTITUTES}/institutes/approved`,
		GET_COMMITTEE_FINALIZED: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/finalized?`,
		GET_ATTACHMENT_URL: (key: string) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/attachments/${key}`,
		GET_APPLICATION_PREDICTION: (applicationId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATION_PREDICTION(applicationId)}`,
		GET_COMMITTEE_MEMBERS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/applications`,
		GET_APPLICATION_COURSES_WITH_LABS: (applicationUuid: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationUuid}/courses-with-labs`,
		GET_ACADEMIC_CALENDARS: (
			page: number,
			limit: number,
			filters?: { isActive?: boolean; isCurrentOrPast?: boolean },
		) => {
			const query = new URLSearchParams();
			query.set("page", String(page));
			query.set("limit", String(limit));
			if (filters?.isActive != null) {
				query.set("isActive", String(filters.isActive));
			}
			if (filters?.isCurrentOrPast != null) {
				query.set("isCurrentOrPast", String(filters.isCurrentOrPast));
			}
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendars?${query.toString()}`;
		},
		/** Active academic year sessions only (`isActive=true`), paginated — dashboard session picker. */
		GET_ACADEMIC_CALENDARS_ACTIVE: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendars?page=${page}&limit=${limit}&isActive=true`,
		GET_PRIORITIES: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/priority?page=${page}&limit=${limit}`,
		GET_EVENT_TYPES: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/event-type?page=${page}&limit=${limit}&isActive=true`,
		/** Event types for Events Request filters — optional authorityCode to load full catalog across authorities. */
		GET_EVENT_TYPES_LIST: (params: {
			page?: number;
			limit?: number;
			isActive?: boolean;
			authorityCode?: string;
			search?: string;
		}) => {
			const query = new URLSearchParams();
			query.set("page", String(params.page ?? 1));
			query.set("limit", String(params.limit ?? 100));
			if (params.isActive != null) query.set("isActive", String(params.isActive));
			if (params.authorityCode?.trim()) query.set("authorityCode", params.authorityCode.trim());
			if (params.search?.trim()) query.set("search", params.search.trim());
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/event-type?${query.toString()}`;
		},
		GET_APPLIES_TO: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applies-to?page=${page}&limit=${limit}`,
		GET_AUTHORITIES: (page: number, limit: number, isActive = true) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/authorities?page=${page}&limit=${limit}&isActive=${isActive}`,
		/** List academic calendar events (Events Request filters: endorsementStatus, eventTypeUuid, etc.). */
		LIST_ACADEMIC_CALENDAR_EVENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events`,
		GET_CALENDAR_EVENTS: (academicCalendarId: string, page: number, limit: number, isActive = true) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events?page=${page}&limit=${limit}&academicCalendarId=${academicCalendarId}&isActive=${isActive}`,
		GET_LINKABLE_ADMISSIONS: (
			targetEventTypeUuid: string,
			academicCalendarId: string,
			page: number,
			limit: number,
		) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/linkable-admissions?page=${page}&limit=${limit}&targetEventTypeUuid=${encodeURIComponent(targetEventTypeUuid)}&academicCalendarId=${encodeURIComponent(academicCalendarId)}`,
		CREATE_CALENDAR_EVENT: `${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events`,
		GET_CALENDAR_EVENT_DETAILS: (eventId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/${eventId}`,
		UPDATE_CALENDAR_EVENT: (eventId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/${eventId}`,
		/** Pending endorsement queue (legacy / alternate). */
		GET_PENDING_ENDORSEMENT_EVENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/pending-endorsement`,
		BULK_ENDORSE_CALENDAR_EVENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/bulk-endorse`,
		BULK_REJECT_CALENDAR_EVENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/bulk-reject`,
		ENDORSE_CALENDAR_EVENT: (eventId: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/${eventId}/endorse`,
		REJECT_CALENDAR_EVENT_ENDORSEMENT: (eventId: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/${eventId}/reject`,
		CLONE_CALENDAR_EVENT: (eventId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/${eventId}/clone`,
		BULK_CLONE_CALENDAR_EVENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendar-events/bulk-clone`,
		CREATE_ACADEMIC_CALENDAR: `${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendars`,
		GET_CURRENT_ACADEMIC_CALENDAR: `${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendars/current`,
		UPDATE_ACADEMIC_CALENDAR_STATUS: (calendarId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendars/${calendarId}`,
		GET_REGISTRATION_CHALLAN_FEE: (calendarUuid: string, registrationEventType: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/academic-calendars/${encodeURIComponent(calendarUuid)}/registration-challan-fee?registrationEventType=${encodeURIComponent(registrationEventType)}`,
		GET_CERTIFIED_INSTITUTES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/institutes/certified`,
		GET_ALL_TRADES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/courses`,
		GET_INSTITUTE_COURSES: (instituteId: number | string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/${instituteId}/institute-courses`,
		GET_INSTITUTE_COURSES_WITH_PENDING: (instituteId: number | string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/${instituteId}/institute-courses/with-pending`,
		/** Unfiltered session list — prefer `GET_ACADEMIC_CALENDARS` with `isCurrentOrPast` for dropdowns. */
		GET_APPLICATION_SESSIONS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/system/filters/application-sessions`,
		GET_APPLICATION_TYPES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/types`,
		GET_TERMS: (page: number, limit: number) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/terms?page=${page}&limit=${limit}`,
		GET_SHIFTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/shift`,
		GET_INSTITUTE_SHIFTS: (instituteId: number, courseId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/students/institute/${instituteId}/shifts?courseId=${courseId}`,
		GET_ASSESSMENT_BODIES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/assessment-body`,
		GET_TEACHING_MODES: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/teaching-mode?page=${page}&limit=${limit}`,
		GET_FEE_MODES: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/fee-mode?page=${page}&limit=${limit}`,
		CREATE_TRADE_SESSION: `${MICRO_SERVICE_ROUTES.INSTITUTES}/trade-session`,
		GET_MATCHED_TRADES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/trade-session/matched-trades`,
		GET_SESSION_DEFAULTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/trade-session/session-defaults`,
		GET_ALLOTTED_CAPACITY: (instituteId: string, tradeId: string, academicYearSessionId: string, shiftId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/trade-session/allotted-capacity?instituteId=${instituteId}&tradeId=${tradeId}&academicYearSessionId=${academicYearSessionId}&shiftId=${shiftId}`,
		GET_TRADE_SESSIONS: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/trade-session?page=${page}&limit=${limit}`,
		DELETE_TRADE_SESSION: (sessionUuid: string) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/trade-session/${sessionUuid}`,
		GET_SESSION_STATUSES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/trade-session/session-statuses`,
		GET_REPORTS_OVERVIEW_STATS: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/overview-stats${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_ATTENDANCE_STATS: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/attendance-stats${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_GENDER_DISTRIBUTION: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/gender-distribution${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_GENDER_DISAGGREGATED: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/gender-disaggregated${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_TRADE_WISE_COMPARISON: (page: number, limit: number, sessionUuids?: string[], search?: string) => {
			const params = new URLSearchParams({ page: page.toString(), limit: limit.toString() });
			appendReportSessionUuidParams(params, sessionUuids);
			if (search) params.append("search", search);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/trade-wise-comparison?${params.toString()}`;
		},
		GET_REPORTS_ENROLLMENT_TRENDS: (page: number, limit: number, sessionUuids?: string[]) => {
			const params = new URLSearchParams({ page: page.toString(), limit: limit.toString() });
			appendReportSessionUuidParams(params, sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/enrollment-trends?${params.toString()}`;
		},
		GET_REPORTS_JOB_PLACEMENT_TRENDS: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/job-placement-trends${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_TOP_MARKET_SKILLS: (page: number, limit: number, sessionUuids?: string[]) => {
			const params = new URLSearchParams({ page: page.toString(), limit: limit.toString() });
			appendReportSessionUuidParams(params, sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/top-market-skills?${params.toString()}`;
		},
		GET_REPORTS_DAILY_ATTENDANCE_TREND: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/daily-attendance-trend${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_ATTENDANCE_TREND: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/attendance-trend${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_STATS: (params?: { sessionUuids?: string[]; districtUuid?: string }) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/dashboard${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_SCHEMES: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
			status?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			if (params?.status) searchParams.append("status", params.status);
			if (params?.page != null) searchParams.set("page", String(params.page));
			if (params?.limit != null) searchParams.set("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/schemes${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_SECTORS: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
			status?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			if (params?.status) searchParams.append("status", params.status);
			if (params?.page != null) searchParams.set("page", String(params.page));
			if (params?.limit != null) searchParams.set("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/sectors${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_INSTITUTE_COUNTS: (params?: { sessionUuids?: string[]; districtUuid?: string }) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/institute-counts${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_COURSE_STREAMS: (params?: { sessionUuids?: string[]; districtUuid?: string }) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/course-streams${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_ENROLLMENT_BY_GENDER: (params?: { sessionUuids?: string[]; districtUuid?: string }) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/enrollment-by-gender${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_ENROLLMENT_VS_GRADUATES: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/enrollment-vs-graduates${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_ENROLLMENT_BY_OWNERSHIP: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/enrollment-by-ownership${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_ENROLLMENT_BY_DISTRICT: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			if (params?.page != null) searchParams.set("page", String(params.page));
			if (params?.limit != null) searchParams.set("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/enrollment-by-district${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_ENROLLMENT_TRENDS: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			if (params?.page != null) searchParams.set("page", String(params.page));
			if (params?.limit != null) searchParams.set("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/enrollment-trends${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_ENROLLMENT_BY_YEAR: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			if (params?.page != null) searchParams.set("page", String(params.page));
			if (params?.limit != null) searchParams.set("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/enrollment/by-year${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_PLACEMENTS_BY_OWNERSHIP: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/placements/by-ownership${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_PLACEMENTS_BY_DISTRICT: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			if (params?.page != null) searchParams.set("page", String(params.page));
			if (params?.limit != null) searchParams.set("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/placements/by-district${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_PLACEMENTS_BY_YEAR: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			if (params?.page != null) searchParams.set("page", String(params.page));
			if (params?.limit != null) searchParams.set("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/placements/by-year${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_PLACEMENTS_BY_TRADE: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			if (params?.page != null) searchParams.set("page", String(params.page));
			if (params?.limit != null) searchParams.set("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/placements/by-trade${query ? `?${query}` : ""}`;
		},
		GET_CM_DASHBOARD_PLACEMENTS_BY_INSTITUTE: (params?: {
			sessionUuids?: string[];
			districtUuid?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params?.sessionUuids);
			if (params?.districtUuid) searchParams.append("districtUuid", params.districtUuid);
			if (params?.page != null) searchParams.set("page", String(params.page));
			if (params?.limit != null) searchParams.set("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/cm-dashboard/placements/by-institute${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_KPI_STATS: (sessionId?: string) =>
			sessionId
				? `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/kpi-stats?sessionId=${sessionId}`
				: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/kpi-stats`,
		GET_REPORTS_KPI_PERFORMANCE: (page: number, limit: number, sessionId?: string) => {
			const params = new URLSearchParams({ page: page.toString(), limit: limit.toString() });
			if (sessionId) params.append("sessionId", sessionId);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/kpi-performance?${params.toString()}`;
		},
		GET_REPORTS_ANALYTIC_STATS: (sessionId?: string) =>
			sessionId
				? `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/analytic-stats?sessionId=${sessionId}`
				: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/analytic-stats`,
		GET_REPORTS_AVERAGE_SALARY: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/average-salary${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_DEMAND_AND_EMPLOYMENT: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/demand-and-employment${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_ENROLLMENT_PLACEMENT_CONVERSION: (sessionId?: string) =>
			sessionId
				? `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/enrollment-placement-conversion?sessionId=${sessionId}`
				: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/enrollment-placement-conversion`,
		GET_REPORTS_AVERAGE_WAGES_BY_SECTOR: (sessionId?: string) =>
			sessionId
				? `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/average-wages-by-sector?sessionId=${sessionId}`
				: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/average-wages-by-sector`,
		GET_REPORTS_SECTORWISE_JOB_PLACEMENT: (page: number, limit: number, sessionId?: string) => {
			const params = new URLSearchParams({ page: page.toString(), limit: limit.toString() });
			if (sessionId) params.append("sessionId", sessionId);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/sectorwise-job-placement?${params.toString()}`;
		},
		GET_REPORTS_TRADE_WISE_APPLICATION: (page: number, limit: number, sessionId?: string) => {
			const params = new URLSearchParams({ page: page.toString(), limit: limit.toString() });
			if (sessionId) params.append("sessionId", sessionId);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/trade-wise-application?${params.toString()}`;
		},
		GET_REPORTS_EMPLOYMENT_TYPE_SPLIT: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/me/employment-type-split${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_ENROLLMENT_PASSOUT_PLACEMENT_TRENDS: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/me/enrollment-passout-placement-trends${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_PLACEMENT_RATE_TOP_SECTORS: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/me/placement-rate-top-sectors${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_REGION_WISE_ATTENDANCE: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/me/region-wise-attendance${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_SECTOR_CAPACITY_OVERVIEW: (sessionUuids?: string[], limit = 5) => {
			const params = new URLSearchParams({ limit: limit.toString() });
			appendReportSessionUuidParams(params, sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/me/sector-capacity-overview?${params.toString()}`;
		},
		GET_REPORTS_GENDER_RETENTION_COMPLETION: (sessionUuids?: string[], genderId?: number) => {
			const params = new URLSearchParams();
			appendReportSessionUuidParams(params, sessionUuids);
			if (genderId !== undefined) params.append("genderId", genderId.toString());
			const query = params.toString();
			return query
				? `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/me/gender-retention-completion?${query}`
				: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/me/gender-retention-completion`;
		},
		GET_REPORTS_JOB_PLACEMENTS_WAGES_BY_SECTOR: (sessionUuids?: string[], genderId?: number) => {
			const params = new URLSearchParams();
			appendReportSessionUuidParams(params, sessionUuids);
			if (genderId !== undefined) params.append("genderId", genderId.toString());
			const query = params.toString();
			return query
				? `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/me/job-placements-wages-by-sector?${query}`
				: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/me/job-placements-wages-by-sector`;
		},
		GET_REPORTS_COURSE_QUALITY_RATINGS: (sessionUuids?: string[]) => {
			const query = buildReportSessionUuidQuery(sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/me/course-quality-ratings${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_SECTOR_SKILL_DEMAND_TRENDS: (sessionUuids?: string[], limit = 5) => {
			const params = new URLSearchParams({ limit: limit.toString() });
			appendReportSessionUuidParams(params, sessionUuids);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/me/sector-skill-demand-trends?${params.toString()}`;
		},
		GET_REPORTS_PROJECT_PERFORMANCE: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/project-performance`,
		GET_REPORTS_RISK_ASSESSMENT: `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/risk-assessment`,
		GET_REPORTS_COMPONENT_PROGRESS: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/component-progress?page=${page}&limit=${limit}`,
		GET_REPORTS_MIS_INSTITUTE_CAPACITY_STATS: (params: {
			sessionUuids?: string[];
			districtUuid?: string;
			instituteUuid?: string;
			courseUuid?: string;
			organizationUuid?: string;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			appendMisReportFilterParams(searchParams, params);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/institute-capacity-stats${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_MIS_INSTITUTE_CAPACITY_WITH_ENROLLMENT: (params: {
			sessionUuids?: string[];
			districtUuid?: string;
			instituteUuid?: string;
			courseUuid?: string;
			organizationUuid?: string;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			appendMisReportFilterParams(searchParams, params);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/institute-capacity-with-enrollment${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_MIS_CAPACITY_UTILIZATION_BY_DISTRICT: (params: {
			sessionUuids?: string[];
			districtUuid?: string;
			instituteUuid?: string;
			courseUuid?: string;
			organizationUuid?: string;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			appendMisReportFilterParams(searchParams, params);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/capacity-utilization-by-district${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_MIS_CAPACITY_UTILIZATION_BY_SECTOR: (params: {
			sessionUuids?: string[];
			districtUuid?: string;
			instituteUuid?: string;
			courseUuid?: string;
			organizationUuid?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			appendMisReportFilterParams(searchParams, params);
			if (params.page != null) searchParams.append("page", String(params.page));
			if (params.limit != null) searchParams.append("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/capacity-utilization-by-sector${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_TEVTA_SUMMARY: (params: { sessionUuids?: string[] }) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/tevta-summary${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_MIS_TRADE_WISE_SUMMARY: (params: {
			sessionUuids?: string[];
			districtUuid?: string;
			instituteUuid?: string;
			courseUuid?: string;
			organizationUuid?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			appendMisReportFilterParams(searchParams, params);
			if (params.page != null) searchParams.append("page", String(params.page));
			if (params.limit != null) searchParams.append("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/trade-wise-summary${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_MIS_APPLICATIONS_DISTRICT_WISE: (params: {
			sessionUuids?: string[];
			districtUuid?: string;
			instituteUuid?: string;
			courseUuid?: string;
			organizationUuid?: string;
			page?: number;
			limit?: number;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			appendMisReportFilterParams(searchParams, params);
			if (params.page != null) searchParams.append("page", String(params.page));
			if (params.limit != null) searchParams.append("limit", String(params.limit));
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/applications-district-wise${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_MIS_STUDENT_DETAILS: (params: {
			sessionUuids?: string[];
			districtUuid?: string;
			instituteUuid?: string;
			courseUuid?: string;
			organizationUuid?: string;
			page?: number;
			limit?: number;
			genderUuid?: string;
			minAge?: number;
			maxAge?: number;
			status?: string;
		}) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			appendMisReportFilterParams(searchParams, params);
			if (params.page != null) searchParams.append("page", String(params.page));
			if (params.limit != null) searchParams.append("limit", String(params.limit));
			if (params.genderUuid) searchParams.append("genderUuid", params.genderUuid);
			if (params.minAge != null) searchParams.append("minAge", String(params.minAge));
			if (params.maxAge != null) searchParams.append("maxAge", String(params.maxAge));
			if (params.status) searchParams.append("status", params.status);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/student-details${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_MIS_PLACEMENT_STATS: (params: { sessionUuids?: string[] }) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/placement-stats${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_MIS_PLACEMENT_STATS_BY_GENDER: (params: { sessionUuids?: string[] }) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/placement-stats-by-gender${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_MIS_PLACEMENT_STATS_BY_COURSE: (params: { sessionUuids?: string[] }) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/placement-stats-by-course${query ? `?${query}` : ""}`;
		},
		GET_REPORTS_MIS_PLACEMENT_STATS_BY_DISTRICT: (params: { sessionUuids?: string[] }) => {
			const searchParams = new URLSearchParams();
			appendReportSessionUuidParams(searchParams, params.sessionUuids);
			const query = searchParams.toString();
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/reports/mis/placement-stats-by-district${query ? `?${query}` : ""}`;
		},
		// FAQ endpoints
		FAQ_SECTIONS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/faq-sections`,
		FAQ_SECTIONS_WITH_ITEMS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/faq-sections/faqs`,
		FAQ_SECTION_BY_ID: (id: number) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/faq-sections/${id}`,
		FAQ_ITEMS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/faq-items`,
		FAQ_ITEMS_BY_SECTION: (sectionId: number) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/faq-items/section/${sectionId}`,
		FAQ_ITEM_BY_ID: (id: number) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/faq-items/${id}`,
		TRACEABILITY_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/traceability/stats`,
		TRACEABILITY_STUDENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/traceability/students`,
		TRACEABILITY_STUDENT_DETAILS: (uuid: string) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/traceability/students/${uuid}`,
		TRACEABILITY_CERTIFIED_INSTITUTES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/institutes/certified-institutes`,
		TRACEABILITY_SECTORS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/sector`,
		TRACEABILITY_DISTRICTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/district`,
		EMPLOYMENT_STATUS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/employments/status`,
		/** Apprenticeship industry partners — list/create; append /:uuid for update/delete */
		APPRENTICESHIP_INDUSTRIES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/apprenticeship/industries`,
		APPRENTICESHIP_INDUSTRY_APPROVED_TRADES: (id: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/apprenticeship/industries/${id}/approved-trades`,
		/** Apprenticeship registrations — list/create; append /:id for detail/update/delete */
		APPRENTICESHIP_APPRENTICES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/apprenticeship/apprentices`,
		APPRENTICESHIP_APPRENTICE_COMPLETION_GRADE_OPTIONS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/apprenticeship/apprentices/completion-grade-options`,
		/** Apprenticeship students — searchable list (page, limit, search) */
		APPRENTICESHIP_STUDENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/apprenticeship/students`,
		APPRENTICESHIP_APPRENTICE_COMPLETION: (id: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/apprenticeship/apprentices/${id}/completion`,
		APPRENTICESHIP_APPRENTICE_TRACEABILITY: (id: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/apprenticeship/apprentices/${id}/traceability`,
		/** GET `?year=` — apprenticeship dashboard summary for institute */
		APPRENTICESHIP_DASHBOARD_SUMMARY: `${MICRO_SERVICE_ROUTES.INSTITUTES}/apprenticeship/dashboard/summary`,
		GET_AUDIT_LOGS: (page: number, limit: number, userId?: number, activityType?: string, from?: string, to?: string, search?: string) => {
			const params = new URLSearchParams({
				page: page.toString(),
				limit: limit.toString(),
			});
			if (userId) params.append("userId", userId.toString());
			if (activityType) params.append("activityType", activityType);
			if (from) params.append("from", from);
			if (to) params.append("to", to);
			if (search) params.append("search", search);
			return `${MICRO_SERVICE_ROUTES.INSTITUTES}/audit-log?${params.toString()}`;
		},
	},
	/** PBTE Assessment Body dashboard — same paths as tvet-assessment-portal `SERVER_ROUTES.DASHBOARD` / `INSTITUTES`. */
	ASSESSMENT_BODY_PBTE_DASHBOARD: {
		STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/assessment-body/dashboard/stats`,
		OFFERED_COURSES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/assessment-body/dashboard/offered-courses`,
		AFFILIATED_INSTITUTES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/assessment-body/dashboard/affiliated-institutes`,
		PLATFORM_REGISTERED_INSTITUTES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/assessment-body/dashboard/platform-registered-institutes`,
		REGISTERED_STUDENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/assessment-body/dashboard/registered-students`,
		PASS_OUT_STUDENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/assessment-body/dashboard/pass-out-students`,
		PBTE_TERM_EXAM_RESULTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/assessment-body/dashboard/pbte-term-exam-results`,
	},
	ASSESSMENT_BODY_PBTE_LOOKUP: {
		CITIES: `${MICRO_SERVICE_ROUTES.INSTITUTES}/city`,
		RELIGION: `${MICRO_SERVICE_ROUTES.INSTITUTES}/religion`,
		GENDER: `${MICRO_SERVICE_ROUTES.INSTITUTES}/gender`,
		COURSE_STREAM: `${MICRO_SERVICE_ROUTES.INSTITUTES}/course-stream`,
		INSTITUTE_COURSES: (instituteId: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/${instituteId}/institute-courses`,
	},
	CERTIFICATES: {
		GET_CERTIFICATES: (page: number, limit: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/admin/certified?page=${page}&limit=${limit}`,
		GET_DETAILS: (instituteId: string) =>
			`${API_ROUTES.CERTIFICATES}/${instituteId}${API_PATHS.CERTIFICATES.GET_DETAILS}`,
		DOWNLOAD: (certificateId: string) =>
			`${API_ROUTES.CERTIFICATES}/${certificateId}${API_PATHS.CERTIFICATES.DOWNLOAD}`,
	},
	MEMBERS: {
		GET_DETAILS: (memberId: string) => `${API_ROUTES.MEMBERS}/${memberId}/details`,
		TOGGLE_STATUS: (memberId: string) => `${API_ROUTES.MEMBERS}/${memberId}/status`,
	},
} as const;

export const QUERY_KEYS = {
	USER: {
		PROFILE_IMAGE_UPDATE: "profile-image-update",
		PROFILE_UPDATE: "profile-update",
		GET_PROFILE: "profile",
		COMMITTE_MEMBERS: "committee-members",
		MEMBERS: "members",
		USER_ROLES: "user-roles",
		PERMISSION_MODULES: "permission-modules",
		ROLES: "roles",
		USERS: "users",
	},
	INSTITUTES: {
		INSTITUTES: "institutes",
		INSTITUTE_DETAILS: "institute-details",
		APPLICATION_DETAILS: "application-details",
		APPLICATION_COURSE_LABS: "application-course-labs",
		LAB_EQUIPMENTS_PAGINATED: "lab-equipments-paginated",
		COMMITTEE_DETAILS: "committee-details",
		EQUIPMENTS: "equipment",
		LABS: "labs",
		MEMBER_TYPE: "member-type",
		TECHNOLOGIES: "technologies",
		DESIGNATIONS: "designations",
		QUALIFICATIONS: "qualifications",
		TECH_QUALIFICATIONS: "tech-qualifications",
		PROVINCES: "provinces",
		DIVISIONS: "divisions",
		DISTRICTS: "districts",
		TEHSILS: "tehsils",
		CITIES: "cities",
		UNION_COUNCEL: "unionCouncils",
		COURSE_STREAM: "course-stream",
		COURSE_LEVEL: "course-level",
		COMPETENCY_POINTS: "competency-points",
		EXAM_SYSTEM: "exam-system",
		COURSE_NOTIFYING_AUTHORITY: "course-notifying-authority",
		COURSE_CATEGORY: "course-category",
		COURSE_SCHEME: "course-scheme",
		COURSE_DURATION: "course-duration",
		COURSE_LABEL: "course-label",
		COURSE_ASSIGN: "course-assign",
		COURSE_ASSIGN_SPECIAL_INITIATIVE: "course-assign-special-initiative",
		COURSE_ASSIGN_COURSES: "course-assign-courses",
		SUBJECTS: "subjects",
		COURSES: "courses",
		COURSE_CATEGORIES: "course-categories",
		COURSE_TERM_COUNT: "course-term-count",
		COURSE_REQUESTS: "course-requests",
		COURSE_DETAILS: "courseDetails",
		COURSE_ATTACHMENT_LABELS: "course-attachment-labels",
		SECTOR: "sector",
		ASSESSMENT_BODY: "assessment-body",
		APPLICATIONS_PENDING: "applications-pending",
		APPLICATIONS_SCRUTINIZED: "applications-scrutinized",
		APPLICATIONS_INSPECTED: "applications-inspected",
		APPLICATIONS_REJECTED: "applications-rejected",
		APPLICATIONS_REFERRED_BACK: "applications-referred-back",
		APPLICATIONS_APPROVED: "applications-approved",
		APPLICATIONS_APPEALS: "applications-appeals",
		PENDING_CERTIFICATES: "pending-certificates",
		COMMITTEE_APPROVAL_PENDING: "committee-approval-pending",
		COMMITTEE_APPROVED: "committee-approved",
		COMMITTEE_REJECTED: "committee-rejected",
		COMMITTEE_FINALIZED: "committee-finalized",
		RECONSTITUTE_PENDING: "reconstitute-pending",
		INSPECTION_TYPES: "inspection-types",
		INSPECTION_APPLICATIONS: "inspection-applications",
		INSPECTION_STATS: "inspection-stats",
		COMMITTEE_MEMBERS: "committee-members",
		DASHBOARD_STATS: "dashboard-stats",
		DASHBOARD_PIE_STATS: "dashboard-pie-stats",
		DASHBOARD_BAR_STATS: "dashboard-bar-stats",
		CM_DASHBOARD_STATS: "cm-dashboard-stats",
		CM_DASHBOARD_SCHEMES: "cm-dashboard-schemes",
		CM_DASHBOARD_SECTORS: "cm-dashboard-sectors",
		CM_DASHBOARD_INSTITUTE_COUNTS: "cm-dashboard-institute-counts",
		CM_DASHBOARD_INSTITUTES: "cm-dashboard-institutes",
		CM_DASHBOARD_COURSE_STREAMS: "cm-dashboard-course-streams",
		CM_DASHBOARD_COURSES: "cm-dashboard-courses",
		CM_DASHBOARD_ENROLLMENT_BY_GENDER: "cm-dashboard-enrollment-by-gender",
		CM_DASHBOARD_ENROLLMENT_VS_GRADUATES: "cm-dashboard-enrollment-vs-graduates",
		CM_DASHBOARD_ENROLLMENT_BY_OWNERSHIP: "cm-dashboard-enrollment-by-ownership",
		CM_DASHBOARD_ENROLLMENT_BY_DISTRICT: "cm-dashboard-enrollment-by-district",
		CM_DASHBOARD_ENROLLMENT_TRENDS: "cm-dashboard-enrollment-trends",
		CM_DASHBOARD_ENROLLMENT_BY_YEAR: "cm-dashboard-enrollment-by-year",
		CM_DASHBOARD_PLACEMENTS_BY_OWNERSHIP: "cm-dashboard-placements-by-ownership",
		CM_DASHBOARD_PLACEMENTS_BY_DISTRICT: "cm-dashboard-placements-by-district",
		CM_DASHBOARD_PLACEMENTS_BY_YEAR: "cm-dashboard-placements-by-year",
		CM_DASHBOARD_PLACEMENTS_BY_TRADE: "cm-dashboard-placements-by-trade",
		CM_DASHBOARD_PLACEMENTS_BY_INSTITUTE: "cm-dashboard-placements-by-institute",
		EXECUTIVE_DASHBOARD_STATS: "executive-dashboard-stats",
		EXECUTIVE_FILTER_OPTIONS: "executive-filter-options",
		INSTITUTE_STREAM: "institute-stream",
		INSTITUTES_APPROVED_EXECUTIVE: "institutes-approved-executive",
		APPLICATION_SESSIONS: "application-sessions",
		APPLICATION_TYPES: "application-types",
		ORGANIZATION_TYPE: "organization-type",
		ORGANIZATION_CATEGORY: "organization-category",
		ATTACHMENT_TYPE: "attachment-type",
		ATTACHMENT_TYPE_OPTION: "attachment-type-option",
		INSTITUTE_FACILITY: "institute-facility",
		FACILITY_TYPE_FILTER: "facility-type-filter",
		PAYMENT_MODE_FILTER: "payment-mode-filter",
		EMPLOYMENT_TYPE_FILTER: "employment-type-filter",
		APPLICATION_PREDICTION: "application-prediction",
		APPLICATION_COURSES_WITH_LABS: "application-courses-with-labs",
		ACADEMIC_CALENDARS: "academic-calendars",
		ACADEMIC_CALENDARS_INFINITE: "academic-calendars-infinite",
		ACADEMIC_CALENDARS_ACTIVE_INFINITE: "academic-calendars-active-infinite",
		REGISTRATION_CHALLAN_FEE: "registration-challan-fee",
		TRADE_SESSIONS: "trade-sessions",
		MATCHED_TRADES: "matched-trades",
		SESSION_DEFAULTS: "session-defaults",
		ADMISSION_QUOTA: "admission-quota",
		INSTITUTE_COURSES_WITH_PENDING: "institute-courses-with-pending",
		ALLOTTED_CAPACITY: "allotted-capacity",
		CERTIFIED_INSTITUTES: "certified-institutes",
		ALL_TRADES: "all-trades",
		APPRENTICESHIP_INDUSTRIES: "apprenticeship-industries",
		APPRENTICESHIP_INDUSTRY_DETAIL: "apprenticeship-industry-detail",
		APPRENTICESHIP_INDUSTRY_APPROVED_TRADES: "apprenticeship-industry-approved-trades",
		APPRENTICESHIP_APPRENTICES: "apprenticeship-apprentices",
		APPRENTICESHIP_APPRENTICE_COMPLETION_GRADE_OPTIONS: "apprenticeship-apprentice-completion-grade-options",
		APPRENTICESHIP_APPRENTICE_DETAIL: "apprenticeship-apprentice-detail",
		APPRENTICESHIP_STUDENTS: "apprenticeship-students",
		APPRENTICESHIP_DASHBOARD_SUMMARY: "apprenticeship-dashboard-summary",
		SHIFTS: "shifts",
		SESSION_STATUSES: "session-statuses",
		PRIORITIES: "priorities",
		EVENT_TYPES: "event-types",
		EVENT_TYPES_ALL_FILTER: "event-types-all-filter",
		APPLIES_TO: "applies-to",
		AUTHORITIES: "authorities",
		CALENDAR_EVENTS: "calendar-events",
		LINKABLE_ADMISSIONS: "linkable-admissions",
		CALENDAR_EVENT_DETAILS: "calendar-event-details",
		PENDING_ENDORSEMENT_EVENTS: "pending-endorsement-events",
		UNAUTHORIZED_INSTITUTE_REPORTS: "unauthorized-institute-reports",
		EMPLOYER_SDED_ENDORSEMENTS: "employer-sded-endorsements",
		EMPLOYER_SDED_ENDORSEMENT_DETAIL: "employer-sded-endorsement-detail",
	},
	CERTIFICATES: {
		GET_CERTIFICATES: "certificates",
		DETAILS: "certificate-details",
		DOWNLOAD: "certificate-download",
	},
	MEMBERS: {
		DETAILS: "member-details",
		STATUS: "member-status",
		COMMITTEE_MEMBER_DETAILS: "committee-member-details",
		ACTIVATE_MEMBER: "activate-member",
		DEACTIVATE_MEMBER: "deactivate-member",
	},
	REPORTS: {
		OVERVIEW_STATS: "overview-stats",
		ATTENDANCE_STATS: "attendance-stats",
		GENDER_DISTRIBUTION: "gender-distribution",
		GENDER_DISAGGREGATED: "gender-disaggregated",
		TRADE_WISE_COMPARISON: "trade-wise-comparison",
		ENROLLMENT_TRENDS: "enrollment-trends",
		JOB_PLACEMENT_TRENDS: "job-placement-trends",
		TOP_MARKET_SKILLS: "top-market-skills",
		DAILY_ATTENDANCE_TREND: "daily-attendance-trend",
		ATTENDANCE_TREND: "attendance-trend",
		KPI_STATS: "kpi-stats",
		KPI_PERFORMANCE: "kpi-performance",
		ANALYTIC_STATS: "analytic-stats",
		AVERAGE_SALARY: "average-salary",
		DEMAND_AND_EMPLOYMENT: "demand-and-employment",
		ENROLLMENT_PLACEMENT_CONVERSION: "enrollment-placement-conversion",
		AVERAGE_WAGES_BY_SECTOR: "average-wages-by-sector",
		SECTORWISE_JOB_PLACEMENT: "sectorwise-job-placement",
		TRADE_WISE_APPLICATION: "trade-wise-application",
		EMPLOYMENT_TYPE_SPLIT: "employment-type-split",
		ENROLLMENT_PASSOUT_PLACEMENT_TRENDS: "enrollment-passout-placement-trends",
		PLACEMENT_RATE_TOP_SECTORS: "placement-rate-top-sectors",
		REGION_WISE_ATTENDANCE: "region-wise-attendance",
		SECTOR_CAPACITY_OVERVIEW: "sector-capacity-overview",
		GENDER_RETENTION_COMPLETION: "gender-retention-completion",
		JOB_PLACEMENTS_WAGES_BY_SECTOR: "job-placements-wages-by-sector",
		COURSE_QUALITY_RATINGS: "course-quality-ratings",
		SECTOR_SKILL_DEMAND_TRENDS: "sector-skill-demand-trends",
		PROJECT_PERFORMANCE: "project-performance",
		RISK_ASSESSMENT: "risk-assessment",
		COMPONENT_PROGRESS: "component-progress",
		MIS_INSTITUTE_CAPACITY_STATS: "mis-institute-capacity-stats",
		MIS_INSTITUTE_CAPACITY_WITH_ENROLLMENT: "mis-institute-capacity-with-enrollment",
		MIS_CAPACITY_UTILIZATION_BY_DISTRICT: "mis-capacity-utilization-by-district",
		MIS_CAPACITY_UTILIZATION_BY_SECTOR: "mis-capacity-utilization-by-sector",
		TEVTA_SUMMARY: "tevta-summary",
		MIS_TRADE_WISE_SUMMARY: "mis-trade-wise-summary",
		MIS_APPLICATIONS_DISTRICT_WISE: "mis-applications-district-wise",
		MIS_STUDENT_DETAILS: "mis-student-details",
		MIS_PLACEMENT_STATS: "mis-placement-stats",
		MIS_PLACEMENT_STATS_BY_GENDER: "mis-placement-stats-by-gender",
		MIS_PLACEMENT_STATS_BY_COURSE: "mis-placement-stats-by-course",
		MIS_PLACEMENT_STATS_BY_DISTRICT: "mis-placement-stats-by-district",
	},
		TRACEABILITY: {
		STATS: "traceability-stats",
		STUDENTS: "traceability-students",
		STUDENT_DETAILS: "traceability-student-details",
		EMPLOYMENT_STATUS: "employment-status",
		CERTIFIED_INSTITUTES: "traceability-certified-institutes",
		SECTORS: "traceability-sectors",
		DISTRICTS: "traceability-districts",
	},
	AUDIT_LOGS: "audit-logs",
	APPLICATIONS: "applications",
	FAQ: {
		SECTIONS: "faq-sections",
		SECTIONS_WITH_ITEMS: "faq-sections-with-items",
		ITEMS: "faq-items",
	},
	ASSESSMENT_BODY_PBTE: {
		STATS: "assessment-body-pbte-dashboard-stats",
		OFFERED_COURSES: "assessment-body-pbte-offered-courses",
		AFFILIATED_INSTITUTES: "assessment-body-pbte-affiliated-institutes",
		PLATFORM_REGISTERED_INSTITUTES: "assessment-body-pbte-platform-registered-institutes",
		CITIES_INFINITE: "assessment-body-pbte-cities-infinite",
		RELIGIONS: "assessment-body-pbte-religions",
		GENDERS: "assessment-body-pbte-genders",
		COURSE_STREAMS: "assessment-body-pbte-course-streams",
		REGISTERED_STUDENTS: "assessment-body-pbte-registered-students",
		PASS_OUT_STUDENTS: "assessment-body-pbte-pass-out-students",
		PBTE_TERM_EXAM_RESULTS: "assessment-body-pbte-term-exam-results",
		APPLICATION_SESSIONS_SELECT: "assessment-body-pbte-application-sessions",
		INSTITUTE_COURSES: "assessment-body-pbte-institute-courses",
	},
};
export const QUERY_PARAMS = {};

export const AUTH_ENDPOINTS = [
	SERVER_ROUTES.AUTH.SIGN_IN,
	SERVER_ROUTES.AUTH.SIGN_UP,
	SERVER_ROUTES.AUTH.FORGOT_PASSWORD,
	SERVER_ROUTES.AUTH.RESET_PASSWORD,
	SERVER_ROUTES.AUTH.VERIFY_OTP,
	SERVER_ROUTES.AUTH.RESEND_OTP,
	SERVER_ROUTES.AUTH.VERIFY_EMAIL,
	SERVER_ROUTES.AUTH.VERIFY_RESET_TOKEN,
	SERVER_ROUTES.AUTH.RESEND_VERIFICATION_LINK,
];
